import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timestampToDate',
    standalone: false
})

export class TimestampToDatePipe implements PipeTransform {
  transform(value: number | string, format: 'ago' | 'date' = 'date'): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    let date: Date;

    if (typeof value === 'number') {
      date = new Date(value);
    } else {
      const parsed = Date.parse(value);
      if (isNaN(parsed)) {
        return '';
      }
      date = new Date(parsed);
    }

    if (isNaN(date.getTime())) {
      return '';
    }
    if (format === 'ago') {
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHour = Math.floor(diffMin / 60);
      const diffDay = Math.floor(diffHour / 24);

      if (diffMs < 0) {
        return 'just now';
      }

      if (diffSec < 60) return `${diffSec} sec ago`;
      if (diffMin < 60) return `${diffMin} min ago`;
      if (diffHour < 24) return `${diffHour} hour${diffHour > 1 ? 's' : ''} ago`;
      return `${diffDay} day${diffDay > 1 ? 's' : ''} ago`;
    }
    return date.toLocaleString();
  }
}
